module.exports = __webpack_public_path__ + "static/media/miel-lapiquera-03.06697157.jpg";